import React, { useState } from 'react';
import '../../styles/modals/StudentInfoModal.css';
import { ReactComponent as DeleteIcon } from '../../assets/svg/DeleteIcon.svg';
import { fileSystemUrl } from '../../server/connections';

function Solution({ solution, index, openSolution, confirmRemove }: { solution: any; index: any; openSolution: any; confirmRemove: any }) {
	const [showQuestion, setShowQuestion] = useState(true);

	return (
		<div
			className='my-[5px] flex cursor-pointer flex-row gap-5 rounded-[10px] border border-[#F8F8FB] bg-[#F8F8FB] px-[30px] py-[20px] duration-300 ease-out hover:border-mudPurple'
			key={solution?.id}
			onClick={(e) => {
				e.preventDefault();
				e.stopPropagation();
				openSolution(solution);
			}}
		>
			{!!solution.image && (
				<div className='w-full max-w-[160px] rounded-xl '>
					<img style={{ objectFit: 'contain', width: '100%', minHeight: 80, maxHeight: 80 }} src={fileSystemUrl + '/' + solution.image?.url} alt='' />
				</div>
			)}
			<div className=' ml-5 mr-3 flex flex-1 flex-col '>
				<p className='text-[18px] font-semibold text-[#5E639B]'>Solution {index + 1}</p>
				<p className='text-[18px] font-semibold text-[#5E639B]'>Title: {solution?.title}</p>
			</div>

			<div className='flex items-center justify-center '>
				<div
					className='rounded-full min-w-10 h-10 hover:bg-greyLight flex items-center justify-center '
					onClick={(e) => {
						e.stopPropagation();
						confirmRemove(index);
					}}
				>
					<DeleteIcon style={{ color: '#5E639B' }} />
				</div>
			</div>
		</div>
	);
}

export default Solution;
